export const ThreeDotsSceneItems = () => `
<div class="three-dots-people-container">
  <nav class="menu-container" role="menu">
    <div class="menu-item" role="menuitem" tabindex="0" data-lang="show-user-info-text">View profile</div>
    <div class="menu-item" role="menuitem" tabindex="0" data-lang="chat-text">Chat</div>
    <div class="menu-item" role="menuitem" tabindex="0" data-lang="video-call-text">Start video call</div>
    <div class="menu-item" role="menuitem" tabindex="0" data-lang="start-one-on-one-tour-text">Start One-on-One Tour</div>
    <div class="menu-item" role="menuitem" tabindex="0" data-lang="remove-from-friends-text">Remove from friends</div>
    <div class="menu-item" role="menuitem" tabindex="0" data-lang="add-as-friend-text">Add as friend</div>
    <div class="menu-item" role="menuitem" tabindex="0" data-lang="invite-to-chess-game-text">Invite to Chess Game</div>
  </nav>
</div>
`;

export const ThreeDotsRoomItems = () => `
<div class="three-dots-people-container">
  <nav class="menu-container" role="menu">
  <div class="menu-item" role="menuitem" tabindex="0" data-lang="show-user-info-text" >View profile</div>
    <div class="menu-item" role="menuitem" tabindex="0" data-lang="chat-text">Chat</div>
    <div class="menu-item" role="menuitem" tabindex="0" data-lang="video-call-text" >Start video call</div>
    <div class="menu-item" role="menuitem" tabindex="0" data-lang="jump-to-scene-text">Jump to scene</div>
    <div class="menu-item" role="menuitem" tabindex="0" data-lang="invite-to-scene-text">Invite to scene</div>
    <div class="menu-item" role="menuitem" tabindex="0" data-lang="start-one-on-one-tour-text">Start One-on-One Tour</div>
    <div class="menu-item" role="menuitem" tabindex="0" data-lang="remove-from-friends-text">Remove from friends</div>
    <div class="menu-item" role="menuitem" tabindex="0" data-lang="add-as-friend-text">Add as friend</div>
      <div class="menu-item" role="menuitem" tabindex="0" data-lang="invite-to-chess-game-text">Invite to Chess Game</div>
  </nav>
</div>
`;

export const ThreeDotsOnlineFriendsItems = () => `
<div class="three-dots-people-container">
  <nav class="menu-container" role="menu">
    <div class="menu-item" role="menuitem" tabindex="0" data-lang="remove-from-friends-text">Remove from friends</div>
    <div class="menu-item" role="menuitem" tabindex="0" data-lang="add-as-friend-text">Add as friend</div>
    <div class="menu-item" role="menuitem" tabindex="0" data-lang="show-user-info-text">View profile</div>
    <div class="menu-item" role="menuitem" tabindex="0" data-lang="start-one-on-one-tour-text">Start One-on-One Tour</div>
    <div class="menu-item" role="menuitem" tabindex="0" data-lang="video-call-text">Start video call</div>
    <div class="menu-item" role="menuitem" tabindex="0" data-lang="jump-to-scene-text">Jump to scene</div>
    <div class="menu-item" role="menuitem" tabindex="0" data-lang="invite-to-scene-text">Invite to scene</div>
  </nav>
</div>
`;

export const ThreeDotsPodiumItems = () => `
<div class="three-dots-people-container">
  <nav class="menu-container" role="menu">
    <div class="menu-item" role="menuitem" tabindex="0" data-lang="show-user-info-text">View profile</div>
    <div class="menu-item" role="menuitem" tabindex="0" data-lang="remove-from-podium-text">Remove from podium</div>
    <div class="menu-item menu-item--danger" role="menuitem" tabindex="0" data-lang="remove-from-tour-text">Remove from tour</div>
  </nav>
</div>
`;

export const ThreeDotsTourGuestsItems = () => `
<div class="three-dots-people-container">
  <nav class="menu-container" role="menu">
    <div class="menu-item" role="menuitem" tabindex="0" data-lang="show-user-info-text">View profile</div>
    <div class="menu-item" role="menuitem" tabindex="0" data-lang="invite-to-podium-menu-text">Invite to podium</div>
    <div class="menu-item menu-item--danger" role="menuitem" tabindex="0" data-lang="remove-from-tour-text">Remove from tour</div>
  </nav>
</div>
`;

export const ThreeDotsTourItems = () => `
<div class="three-dots-people-container">
  <nav class="menu-container" role="menu">
    <div class="menu-item" role="menuitem" tabindex="0" data-lang="remove-from-friends-text">Remove from friends</div>
    <div class="menu-item" role="menuitem" tabindex="0" data-lang="add-as-friend-text">Add as friend</div>
    <div class="menu-item" role="menuitem" tabindex="0" data-lang="show-user-info-text">View profile</div>
    <div class="menu-item" role="menuitem" tabindex="0" data-lang="start-one-on-one-tour-text">Start One-on-One Tour</div>
    <div class="menu-item" role="menuitem" tabindex="0" data-lang="video-call-text">Start video call</div>
  </nav>
</div>
`;

export const ThreeDotsInviteTourItems = () => `
<div class="three-dots-people-container">
  <nav class="menu-container" role="menu">
    <div class="menu-item" role="menuitem" tabindex="0" data-lang="show-user-info-text">View profile</div>
    <div class="menu-item" role="menuitem" tabindex="0" data-lang="invite-to-tour-text">Invite to tour</div>
    <div class="menu-item" role="menuitem" tabindex="0" data-lang="invite-as-tour-guest-text">Invite as tour guest</div>
    <div class="menu-item" role="menuitem" tabindex="0" data-lang="invite-to-podium-menu-text">Invite to podium</div>
  </nav>
</div>
`;

export const ThreeDotsSpaceBrowserItems = () => `
<div class="three-dots-people-container">
  <nav class="menu-container" role="menu">
    <div class="menu-item" role="menuitem" tabindex="0" data-lang="show-user-info-text">View profile</div>
    <div class="menu-item" role="menuitem" tabindex="0" data-lang="remove-from-friends-text">Remove from friends</div>
    <div class="menu-item" role="menuitem" tabindex="0" data-lang="add-as-friend-text">Add as friend</div>
  </nav>
</div>
`;
